var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { ErrorMonitorContext } from './ErrorMonitorProvider';
var ErrorMonitorBoundary = /** @class */ (function (_super) {
    __extends(ErrorMonitorBoundary, _super);
    function ErrorMonitorBoundary(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = { error: null, componentStack: null };
        var errorMonitorFromProps = _this.props.errorMonitor;
        var errorMonitorFromProvider = _this.context;
        if (errorMonitorFromProps) {
            _this.errorMonitorInstance = errorMonitorFromProps;
        }
        else if (errorMonitorFromProvider) {
            _this.errorMonitorInstance = errorMonitorFromProvider;
        }
        else {
            throw new Error('ErrorMonitor is not available.\n Please wrap with ErrorMonitorProvider OR pass ErrorMonitor to the props of <ErrorMonitorBoundary>\n');
        }
        return _this;
    }
    ErrorMonitorBoundary.prototype.componentDidCatch = function (error, _a) {
        var componentStack = _a.componentStack;
        this.errorMonitorInstance.captureException(error, {
            contexts: { react: { componentStack: componentStack, reactVersion: React.version } },
        });
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            componentStack: componentStack,
        });
    };
    ErrorMonitorBoundary.prototype.render = function () {
        var _a, _b, _c, _d, _e;
        var _f = this.props, fallback = _f.fallback, isDebug = _f.isDebug;
        var _g = this.state, componentStack = _g.componentStack, error = _g.error;
        if (componentStack) {
            if (isDebug) {
                (_a = console.group) === null || _a === void 0 ? void 0 : _a.call(console, 'ErrorMonitor::Debug:: Error caught in boundary');
                (_b = console.warn) === null || _b === void 0 ? void 0 : _b.call(console, 'Error:\n', error);
                (_c = console.warn) === null || _c === void 0 ? void 0 : _c.call(console, 'ComponentStack:\n', componentStack);
                (_d = console.warn) === null || _d === void 0 ? void 0 : _d.call(console, 'Fallback:\n', fallback);
                (_e = console.groupEnd) === null || _e === void 0 ? void 0 : _e.call(console);
            }
            return fallback;
        }
        // Normally, just render children
        return this.props.children;
    };
    ErrorMonitorBoundary.contextType = ErrorMonitorContext;
    return ErrorMonitorBoundary;
}(Component));
export { ErrorMonitorBoundary };
//# sourceMappingURL=ErrorMonitorBoundary.js.map